$(function(){
    $("body").on("click","#updateMenuItem",function() {
        $(this).prop("disabled",true);
        var form = $("#updateMenuItemForm");
        var action = $(form).attr("action");
        var inp = form.find("input");
        var data = {};
        inp.each(function(i, item){
            if(!$(item).attr("name") || !$(item).attr("name").length) {
                return;
            }
            if($(item).attr("type") && $(item).attr("type")==='checkbox') {
                if($(item).is(":checked")) {
                    data[$(item).attr("name")] = $(item).val();
                }
            }else {
                data[$(item).attr("name")] = $(item).val();
            }
        });

        data.roles = form.find("select[name=roles\\[\\]] option:selected").map(function(){ return this.value }).get();

        console.log(action,data);
        $.post(action,data,function(data){
            SuccessMessage(data.message);
            setTimeout(function(){
                window.location.reload();
            },500);
        });
        return false;
    });
});